// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"700":"c1281c59","862":"8d7fa27b"}[chunkId] + ".css";
};